import {Instance, SnapshotOut, types} from 'mobx-state-tree'
import {LoginStoreModel} from '../login-store/login-store'
import {withEnvironment} from "../extensions/with-environment";
import {ProjectStoreModel} from "../project-store/project-store";

/**
 * A RootStore model.
 */
// prettier-ignore
export const RootStoreModel = types.model('RootStore').extend(withEnvironment)
  .props({
    loginStore: types.optional(LoginStoreModel, {}),
    projectStore: types.optional(ProjectStoreModel, {}),
    backgroundImage: types.maybeNull(types.string),
  }).views(self => ({}))
  .actions(self => ({
    reset() {
      self.loginStore.reset();
      self.projectStore.reset();
    },
    setBackgroundImage(image: string) {
      self.backgroundImage = image
    }
  }));


/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {
}

/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {
}
